import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles, CircularProgress, Fab, Tooltip } from '@material-ui/core';
import MaterialIcon from '@material-ui/core/Icon';

class FormSendButton extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        tooltipText: PropTypes.string.isRequired,
        sendFunc: PropTypes.func.isRequired,
        sendLoading: PropTypes.bool,
        disabled: PropTypes.bool,
        Icon: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired
    };

    static defaultProps = {
        sendLoading: false,
        disabled: false
    };

    renderIcon = () => {
        const { Icon, classes } = this.props;
        // save: 'check', send: 'send', preview: 'visibility', duplicate: 'file_copy'
        if (typeof Icon === 'string') {
            return <MaterialIcon className={classes.icon}>{Icon}</MaterialIcon>;
        } else {
            return <Icon className={classes.icon} />;
        }
    };

    render() {
        const { sendFunc, sendLoading, classes, tooltipText, disabled } = this.props;

        return sendLoading ? (
            <CircularProgress size={25} />
        ) : (
            <Tooltip title={tooltipText} placement="top">
                <div className={classes.wrapper}>
                    <Fab size="small" disabled={disabled} className={classes.button} onClick={sendFunc}>
                        {this.renderIcon()}
                    </Fab>
                </div>
            </Tooltip>
        );
    }
}

const styles = theme => ({
    button: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        minHeight: 30,
        minWidth: 30,
        [theme.breakpoints.down('xs')]: {
            height: 30,
            width: 30
        }
    },
    wrapper: {
        width: 'fit-content'
    },
    icon: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.2rem'
        }
    }
});

export default withStyles(styles, { withTheme: true })(FormSendButton);



// WEBPACK FOOTER //
// ./data/components/FormButton.js